import type { Maybe } from '@adornis/base/utilTypes.js';
import { Float } from '@adornis/baseql/baseqlTypes.js';
import { DataLoadedField } from '@adornis/baseql/decorators/data-loaded-field.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { getRawCollection } from '@adornis/baseql/server/collections.js';
import { KPF } from '../../master-data-management/kpf/entities/KPF.js';

@Entity()
export class CapacityRequestOverview extends AdornisEntity {
  static override _class = 'CapacityRequestOverview';

  @Field(() => String)
  public KPFID: Maybe<string>;

  @DataLoadedField(() => KPF, ({ KPFID }) => KPFID)
  public kpf: Maybe<KPF>;

  @Field(() => Float)
  public leko: Maybe<number>;

  @Field(() => Float)
  public schuko: Maybe<number>;

  @Field(() => Boolean)
  public highPriority: Maybe<boolean>;

  @Field(() => Boolean, {
    resolve: function (this: CapacityRequestOverview) {
      return async () => {
        const col = await getRawCollection<{ _id: string; notification: boolean }>('capacity-request-meta');
        const doc = await col.findOne({ _id: this.KPFID ?? '' });
        return doc?.notification ?? false;
      };
    },
  })
  public notification: Maybe<boolean>;
}
